var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"item-text":"name","item-value":"value"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }